import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/(utils)/IntlLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/404.png");
